export default "__VITE_ASSET__BT_3mH_m__"